var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-mobile" }, [
    _vm.headerLinks.length
      ? _c("div", { staticClass: "headerlink-container" }, [
          _c(
            "div",
            { staticClass: "nav-section-head row-cb" },
            [
              _vm._v("\n            Travel Tales\n            "),
              _vm._v(" "),
              _c(
                "f9link",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isEs,
                      expression: "!isEs"
                    }
                  ],
                  ref: "esLink",
                  staticClass: "es-link langLink",
                  attrs: {
                    id: "MobileSpanishToggler",
                    "data-href": "es.flyfrontier.com",
                    "data-lang": "es",
                    mporgnav: "",
                    nostyle: ""
                  },
                  on: { click: _vm.redirectLanguage }
                },
                [_vm._v("\n                Español\n            ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-section" },
            [
              _vm._l(_vm.headerLinks, function(headerLink) {
                return _c("f9link", {
                  key: headerLink.id,
                  staticClass: "a nav-section-sub-head row-cb",
                  attrs: {
                    "new-window": headerLink.newWindow,
                    nostyle: "",
                    href: _vm.getLink(headerLink.link)
                  },
                  domProps: { innerHTML: _vm._s(headerLink.text) }
                })
              }),
              _vm._v(" "),
              _c("f9link", {
                staticClass: "a nav-section-sub-head row-cb",
                attrs: {
                  "new-window": false,
                  nostyle: "",
                  href: _vm.getLink("https://www.flyfrontier.com")
                },
                domProps: { innerHTML: _vm._s("FLYFRONTIER.COM") }
              })
            ],
            2
          )
        ])
      : _c("div", [
          _c(
            "div",
            { staticClass: "nav-section-head row-cb" },
            [
              _c("f9link", {
                attrs: {
                  href: _vm.getLink(_vm.menuData.travel.link.link),
                  "new-window": _vm.menuData.travel.link.newWindow,
                  nostyle: ""
                },
                domProps: { innerHTML: _vm._s(_vm.menuData.travel.name) }
              }),
              _vm._v(" "),
              _c(
                "f9link",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isEs,
                      expression: "!isEs"
                    }
                  ],
                  ref: "esLink",
                  staticClass: "es-link langLink",
                  attrs: {
                    id: "MobileSpanishToggler",
                    "data-href": "es.flyfrontier.com",
                    "data-lang": "es",
                    mporgnav: "",
                    nostyle: ""
                  },
                  on: { click: _vm.redirectLanguage }
                },
                [_vm._v("\n                Español\n            ")]
              ),
              _vm._v(" "),
              _c(
                "f9link",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEs,
                      expression: "isEs"
                    }
                  ],
                  ref: "enLink",
                  staticClass: "en-link langLink",
                  attrs: {
                    id: "MobileEnglishToggler",
                    "data-href": "www.flyfrontier.com",
                    "data-lang": "en",
                    nostyle: ""
                  },
                  on: { click: _vm.redirectLanguage }
                },
                [_vm._v("\n                English\n            ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-sections" },
            _vm._l(_vm.menuData.travel.sections, function(section, index) {
              return _c(
                "div",
                { key: section.id, staticClass: "nav-section" },
                [
                  _c(
                    "f9button",
                    {
                      staticClass: "nav-section-sub-head row-cb",
                      class: {
                        expanded: !!section.visible,
                        last: index === _vm.menuData.travel.sections.length - 1
                      },
                      attrs: { nostyle: "", "aria-expanded": section.visible },
                      on: {
                        click: function($event) {
                          section.visible = !section.visible
                        }
                      }
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(section.name) }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "down-arrow",
                        attrs: {
                          src:
                            "https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/downUpArrow.svg",
                          alt: ""
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: section.visible,
                          expression: "section.visible"
                        }
                      ],
                      staticClass: "nav-section-items"
                    },
                    _vm._l(section.links, function(link) {
                      return _c("f9link", {
                        key: link.id,
                        staticClass:
                          "nav-section-item horizontal center left content-link",
                        attrs: {
                          "new-window": link.newWindow,
                          nostyle: "",
                          href: _vm.getLink(link.link)
                        },
                        domProps: { innerHTML: _vm._s(link.caption) }
                      })
                    })
                  )
                ],
                1
              )
            })
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-section-head row-cb" },
            [
              _c("f9link", {
                attrs: {
                  href: _vm.getLink(_vm.menuData.deals.link.link),
                  "new-window": _vm.menuData.deals.link.newWindow,
                  nostyle: ""
                },
                domProps: { innerHTML: _vm._s(_vm.menuData.deals.name) }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-section" },
            _vm._l(_vm.menuData.deals.section.links, function(link, index) {
              return _c("f9link", {
                key: link.id,
                staticClass:
                  "nav-section-item no-parent horizontal center left",
                class: { highlighted: index === 0 },
                attrs: {
                  "new-window": link.newWindow,
                  nostyle: "",
                  href: link.link
                },
                domProps: { innerHTML: _vm._s(link.caption) }
              })
            })
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-section-head row-cb" },
            [
              _c(
                "f9link",
                {
                  staticClass: "horizontal center left content-link",
                  attrs: { href: _vm.getLink(_vm.profileLink), nostyle: "" }
                },
                [
                  _c("i", {
                    domProps: {
                      innerHTML: _vm._s(_vm.menuData.myFrontier.name)
                    }
                  }),
                  _vm._v("\n                 Miles\n                "),
                  _c("span", { staticClass: "sm" }, [_vm._v("sm")])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-section" },
            _vm._l(_vm.menuData.myFrontier.leftSection.links, function(link) {
              return _c("f9link", {
                key: link.id,
                staticClass:
                  "nav-section-item no-parent horizontal center left content-link",
                attrs: {
                  "new-window": link.newWindow,
                  nostyle: "",
                  href: _vm.getLink(link.link)
                },
                domProps: { innerHTML: _vm._s(link.caption) }
              })
            })
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70a253c8", { render: render, staticRenderFns: staticRenderFns })
  }
}